import React from 'react';
import { render } from 'react-dom';
import { connect } from "react-redux"
import ClassNames from 'classnames';

// UI Components
import AlertPanel from "./components/AlertPanel";
import ColorPersoCSS from "./components/ColorPersoCSS"
import ErrorNotifier from "./components/ErrorNotifier"
import MobileMenu from "./components/mobile/MobileMenu";
import SoundBox from "./components/SoundBox"
import Threads from "./components/Threads";
import UsersList from "./components/UsersList";
// import WelcomeSurveyNotification from "./components/WelcomeSurveyNotification";

// App services
import startChat from './redux/middlewares/chatMiddleware';
import Store from "./redux/stores/store";
import {init as chatInitAction} from './redux/actions/chatInitAction';

// Redux Actions
import {
  setMobilePanel
} from "./redux/actions/chatInitAction";

// vars init
var Socket = null;

@connect((Store) => {
  return {
    is_chat_loaded: Store.chat.loaded,
    is_closed: Store.chat.closed,
    luser: Store.luser.user,
    insiders: Store.insiders.online,
    connectedUsersCount: Store.chat.connectedUsersCount,
    mobilePanels: Store.chat.mobilePanels,
    mobileSelected: Store.chat.mobileSelected,
    chatURL: Store.chat.chatURL,
    chatLoginURL: Store.chat.chatLoginURL
  };
})


export default class ChatApp extends React.Component {
  componentWillMount() {
    console.log('.... startChat ....');
    const initAction = chatInitAction({
      livechatId: this.props.livechatId,
      serverUrl: this.props.serverUrl
    });
    this.props.dispatch(initAction);
    Socket = startChat(Store);
  }

  mobilePanelClassName(panelClassName){
    return panelClassName+' '+(this.props.mobilePanels[ panelClassName ]);
  }

  mobilePanelChange(panelToOpen){
      this.props.dispatch( setMobilePanel(panelToOpen) );
   }


  render() {

    if (!this.props.is_chat_loaded || this.props.is_closed){

      var itemClass = {
        'template-mask': true,
        'template-loader': !this.props.is_closed
      }
      return (
        <div>
          <ErrorNotifier />
          <div className={ClassNames(itemClass)} ></div>
        </div>
      )
    }
    else {
      return (
        <div>
          <ColorPersoCSS />
          <ErrorNotifier />
          <AlertPanel />
{/*          {<WelcomeSurveyNotification />}*/}
          <section className='chatpanel'>
            <Threads
              mobilePanelClassName={this.mobilePanelClassName.bind(this)}
              mobilePanelChange={this.mobilePanelChange.bind(this)}
            />
            <UsersList
              mobilePanelClassName={this.mobilePanelClassName.bind(this)}
              mobilePanelChange={this.mobilePanelChange.bind(this)}
            />
          </section>
          <MobileMenu
            mobilePanelClassName={this.mobilePanelClassName.bind(this)}
            mobilePanelChange={this.mobilePanelChange.bind(this)}
          />
          <SoundBox />
        </div>
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/ChatApp.jsx